import { Globals } from "../CoreApp/Globals";

export function InitThousandSeparator() {
  const m = 1234567;
  const result = m.toLocaleString();

  Globals._thousandSeparator = result.replace(/[0-9]/g, "").charAt(0);
}
